import { Dispatch, SetStateAction } from 'react';
import { Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import biasTags from '../../../assets/images/icons/biasTags.svg';
import boxArchive from '../../../assets/images/icons/boxArchive.svg';
import bus from '../../../assets/images/icons/bus.svg';
import carBus from '../../../assets/images/icons/car-bus.svg';
import carTunnel from '../../../assets/images/icons/car-tunnel.svg';
import chartPie from '../../../assets/images/icons/chartPie.svg';
import coinsSidebar from '../../../assets/images/icons/coinsSidebar.svg';
import companySidebar from '../../../assets/images/icons/companySidebar.svg';
import companyUnlock from '../../../assets/images/icons/companyUnlock.svg';
import customersRequests from '../../../assets/images/icons/customersRequests.svg';
import downloadFile from '../../../assets/images/icons/downloadFile.svg';
import fileLines from '../../../assets/images/icons/fileLines.svg';
import filePen from '../../../assets/images/icons/filePen.svg';
import fileSignature from '../../../assets/images/icons/fileSignature.svg';
import fileUpload from '../../../assets/images/icons/fileUpload.svg';
import folderOpen from '../../../assets/images/icons/folderOpen.svg';
import handshake from '../../../assets/images/icons/handshake.svg';
import iagoIcon from '../../../assets/images/icons/iago.svg';
import lock from '../../../assets/images/icons/lock.svg';
import map from '../../../assets/images/icons/map.svg';
import passenger from '../../../assets/images/icons/passenger.svg';
import plusSidebar from '../../../assets/images/icons/plusSidebar.svg';
import reclamation from '../../../assets/images/icons/reclamation.svg';
import route from '../../../assets/images/icons/route.svg';
import searchSidebar from '../../../assets/images/icons/searchSidebar.svg';
import store from '../../../assets/images/icons/store.svg';
import ticket from '../../../assets/images/icons/ticket.svg';
import triangulation from '../../../assets/images/icons/triangulation.svg';
import unlockConsults from '../../../assets/images/icons/unlockConsults.svg';
import user from '../../../assets/images/icons/user.svg';
import userTie from '../../../assets/images/icons/userTie.svg';
import vehicle from '../../../assets/images/icons/vehicle.svg';
import useGetGeneralAppData from '../../../hooks/useGetGeneralAppData';
import { MenuItem } from '../styles';

interface AdminNavbarInterface {
  active: string;
  setGeneralReportsModalShow: Dispatch<SetStateAction<boolean>>;
}

export default function AdminNavbar({ active, setGeneralReportsModalShow }: AdminNavbarInterface) {
  const isAffreightmentPageActive = active === 'Lines' || active === 'Vehicles' || active === 'Passengers' || active === 'Dashboard';
  const isTriangulationPageActive = active === 'Triangulation';

  const isWorkplacesPageActive = active === 'Workplaces';
  const isClientUsersPageActive = active === 'ClientUsers';
  const isAutImplantationPageActive = active === 'AutImplantation';
  const isCompanyPageActive = active === 'Company';
  const isImportVtRegistrationDataPageActive = active === 'ImportVtRegistrationData';
  const registrationsPages = ['ClientUsers', 'AutImplantation', 'Company', 'Workplaces', 'Departments', 'ImportVtRegistrationData'];
  const isSomeRegistrationPageActive = registrationsPages.includes(active);

  const isNewConsultPageActive = active === 'NewConsult';
  const isImportConsultsFilePageActive = active === 'ImportConsultsFile';
  const isSearchConsultsPageActive = active === 'SearchConsults';
  const consultsPages = ['NewConsult', 'SearchConsults', 'ImportConsultsFile'];
  const isSomeConsultPageActive = consultsPages.includes(active);

  const isAuditSearchFilesPageActive = active === 'AuditSearchFiles';
  const isAuditSearchConsultsPageActive = active === 'AuditSearchConsults';
  const isReclamationsPageActive = active === 'Reclamations';
  const isUnlockConsultsPageActive = active === 'UnlockConsults';
  const isReprocessConsultsPageActive = active === 'ReprocessConsults';
  const isAbateConsultsPageActive = active === 'AbateConsults';
  const isCustomersRequestsPageActive = active === 'CustomersRequests';
  const auditPages = ['AuditSearchFiles', 'AuditSearchConsults', 'Reclamations', 'UnlockConsults', 'ReprocessConsults', 'AbateConsults', 'CustomersRequests'];
  const isSomeAuditPageActive = auditPages.includes(active);

  const isInternalUsersPageActive = active === 'InternalUsers';
  const isOperatorsPageActive = active === 'Operators';
  const isVtItensPageActive = active === 'VtItens';
  const isIntegrationPageActive = active === 'Integration';
  const isLinesPageActive = active === 'TransportLines';
  const isUnlockingCompaniesPageActive = active === 'UnlockingCompanies';
  const isPartnersPageActive = active === 'Partners';
  const isBiasTagsPageActive = active === 'BiasTags';
  const internalRegistrationPages = ['UnlockingCompanies', 'Operators', 'VtItens', 'TransportLines', 'InternalUsers', 'Partners', 'Integration', 'BiasTags'];
  const isSomeInternalRegistrationPageActive = internalRegistrationPages.includes(active);

  const { permissions, canAccessIago, canAccessFinancial } = useGetGeneralAppData();
  const companyPermissions = permissions.find((x) => x.codPag === 1);
  const clientUsersPermissions = permissions.find((x) => x.codPag === 3);
  const workplacesPermissions = permissions.find((x) => x.codPag === 4);
  const autImplantationPermissions = permissions.find((x) => x.codPag === 5);
  const routingPermissions = permissions.find((x) => x.codPag === 6);
  const routingFilePermissions = permissions.find((x) => x.codPag === 7);
  const reclamationsPermissions = permissions.find((x) => x.codPag === 8);
  const affreightmentsDashboardPermissions = permissions.find((x) => x.codPag === 9);
  const affreightmentsLinesPermissions = permissions.find((x) => x.codPag === 9);
  const affreightmentsVehiclesPermissions = permissions.find((x) => x.codPag === 11);
  const affreightmentsPassengersPermissions = permissions.find((x) => x.codPag === 12);
  const triangulationPermissions = permissions.find((x) => x.codPag === 13);
  const generalReportsPermissions = permissions.find((x) => x.codPag === 14);
  const routingFilesPermissions = permissions.find((x) => x.codPag === 15);
  const unlockCompaniesPermissions = permissions.find((x) => x.codPag === 16);
  const operatorsPermissions = permissions.find((x) => x.codPag === 17);
  const vtItensPermissions = permissions.find((x) => x.codPag === 18);
  const linesPermissions = permissions.find((x) => x.codPag === 20);
  const internalUsersPermissions = permissions.find((x) => x.codPag === 21);
  const partnersPermissions = permissions.find((x) => x.codPag === 22);
  const customerRequestsPermissions = permissions.find((x) => x.codPag === 15);

  const hasSomeRegistrationPage = companyPermissions?.vizualizar ||
    clientUsersPermissions?.vizualizar ||
    workplacesPermissions?.vizualizar ||
    autImplantationPermissions?.vizualizar;

  const hasSomeConsultsPage = routingPermissions?.vizualizar ||
    routingFilePermissions?.incluir ||
    routingPermissions?.vizualizar;

  const hasSomeAffreightmentsPage = affreightmentsDashboardPermissions?.vizualizar ||
    affreightmentsLinesPermissions?.vizualizar ||
    affreightmentsVehiclesPermissions?.incluir ||
    affreightmentsPassengersPermissions?.vizualizar;

  const hasSomeAuditPage = routingFilesPermissions?.vizualizar ||
    routingPermissions?.vizualizar ||
    reclamationsPermissions?.vizualizar;

  const hasSomeInternalRegistrationPage = unlockCompaniesPermissions?.vizualizar ||
    operatorsPermissions?.vizualizar ||
    vtItensPermissions?.vizualizar ||
    linesPermissions?.vizualizar ||
    internalUsersPermissions?.vizualizar ||
    partnersPermissions?.vizualizar;

  return (
    <>
      {/* Change Password */}
      <Link to="/changePassword">
        <MenuItem active={active === 'ChangePassword'}>
          <img src={lock} alt="home" />
          Alterar Senha
        </MenuItem>
      </Link>

      {/* Registrations */}
      {hasSomeRegistrationPage && (
        <Accordion defaultActiveKey={isSomeRegistrationPageActive ? '0' : undefined} flush>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <MenuItem>
                <img src={filePen} alt="bus" />
                {' '}
              Cadastros
              </MenuItem>
            </Accordion.Header>
            <Accordion.Body>
              {(companyPermissions && companyPermissions.vizualizar) && (
                <Link to="/company">
                  <MenuItem active={isCompanyPageActive}>
                    <img src={companySidebar} alt="company" />
                  Empresa
                  </MenuItem>
                </Link>
              )}

              {(clientUsersPermissions && clientUsersPermissions.vizualizar) && (
                <Link to="/clientUsers">
                  <MenuItem active={isClientUsersPageActive}>
                    <img src={user} alt="user" />
                  Usuários clientes
                  </MenuItem>
                </Link>
              )}

              {workplacesPermissions && workplacesPermissions.vizualizar && (
                <Link to="/workplaces">
                  <MenuItem active={isWorkplacesPageActive}>
                    <img src={store} alt="workplaces" />
                  Locais de trabalho
                  </MenuItem>
                </Link>
              )}

              {/* <Link to="/departments">
              <MenuItem active={isDepartmentsPageActive}>
                <img src={groupLine} alt="departments" />
                Departamentos
              </MenuItem>
            </Link> */}

              {autImplantationPermissions && autImplantationPermissions.vizualizar && (
                <Link to="/autImplantation">
                  <MenuItem active={isAutImplantationPageActive}>
                    <img src={fileSignature} alt="fileSignature" />
                Implantação Automática
                  </MenuItem>
                </Link>
              )}

              <Link to="/importVtRegistrationData">
                <MenuItem active={isImportVtRegistrationDataPageActive}>
                  <img src={fileUpload} alt="newConsult" />
                  Recadastramento de VT
                </MenuItem>
              </Link>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      )}

      {/* Consults */}
      {hasSomeConsultsPage && (
        <Accordion defaultActiveKey={isSomeConsultPageActive ? '0' : undefined} flush>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <MenuItem>
                <img src={map} alt="bus" />
                {' '}
              Roteirização
              </MenuItem>
            </Accordion.Header>
            <Accordion.Body>
              {(routingPermissions?.incluir && routingPermissions?.vizualizar) && (
                <Link to="/consults/new">
                  <MenuItem active={isNewConsultPageActive}>
                    <img src={plusSidebar} alt="newConsult" />
                  Nova Consulta
                  </MenuItem>
                </Link>
              )}

              {routingFilePermissions?.incluir && (
                <Link to="/consults/file">
                  <MenuItem active={isImportConsultsFilePageActive}>
                    <img src={fileUpload} alt="newConsult" />
                  Importar Arquivo
                  </MenuItem>
                </Link>
              )}

              {routingPermissions?.vizualizar && (
                <Link to="/consults/search">
                  <MenuItem active={isSearchConsultsPageActive}>
                    <img src={searchSidebar} alt="searchConsult" />
                  Pesquisar Consultas
                  </MenuItem>
                </Link>
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      )}

      {/* Affreightments */}
      {hasSomeAffreightmentsPage && (
        <Accordion defaultActiveKey={isAffreightmentPageActive ? '0' : undefined} flush>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <MenuItem>
                <img src={bus} alt="bus" />
                {' '}
              Fretamentos
              </MenuItem>
            </Accordion.Header>
            <Accordion.Body>
              {affreightmentsDashboardPermissions && affreightmentsDashboardPermissions.vizualizar && (
                <Link to="/dashboard">
                  <MenuItem active={active === 'Dashboard'}>
                    <img src={chartPie} alt="dashboard" />
                    <label>Dashboard</label>
                  </MenuItem>
                </Link>
              )}

              {affreightmentsLinesPermissions && affreightmentsLinesPermissions.vizualizar && (
                <Link to="/lines">
                  <MenuItem active={active === 'Lines'}>
                    <img src={route} alt="bus" />
                    <label>Linhas</label>
                  </MenuItem>
                </Link>
              )}

              {affreightmentsVehiclesPermissions && affreightmentsVehiclesPermissions.incluir && (
                <Link to="/vehicles">
                  <MenuItem active={active === 'Vehicles'}>
                    <img src={vehicle} alt="bus" />
                    <label>Veículos</label>
                  </MenuItem>
                </Link>
              )}

              {affreightmentsPassengersPermissions && affreightmentsPassengersPermissions.vizualizar && (
                <Link to="/passengers">
                  <MenuItem active={active === 'Passengers'}>
                    <img src={passenger} alt="passageiros" />
                    <label>Passageiros</label>
                  </MenuItem>
                </Link>
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      )}

      {/* Triangulation */}
      {triangulationPermissions && triangulationPermissions.vizualizar && (
        <Link to="/triangulation">
          <MenuItem active={isTriangulationPageActive}>
            <img src={triangulation} alt="home" />
            Triangulação
          </MenuItem>
        </Link>
      )}

      {canAccessIago && (
        <Link to="/iago">
          <MenuItem active={active === 'Iago'}>
            <img src={iagoIcon} alt="iago" />
            Iago
          </MenuItem>
        </Link>
      )}

      {canAccessFinancial && (
        <Link to="/financial/omie-installments">
          <MenuItem active={active === 'OmieInstallments'}>
            <img src={coinsSidebar} alt="omie" />
            Parcelas OMIE
          </MenuItem>
        </Link>
      )}

      {/* Audit - back-office */}
      {hasSomeAuditPage && (
        <Accordion defaultActiveKey={isSomeAuditPageActive ? '0' : undefined} flush>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <MenuItem>
                <img src={boxArchive} alt="boxArchive" />
                {' '}
              Back-Office
              </MenuItem>
            </Accordion.Header>
            <Accordion.Body>
              {routingFilesPermissions && routingFilesPermissions.vizualizar && (
                <Link to="/audit/files">
                  <MenuItem active={isAuditSearchFilesPageActive}>
                    <img src={folderOpen} alt="folderOpen" />
                  Arquivos / Lotes
                  </MenuItem>
                </Link>
              )}

              {routingPermissions?.vizualizar && (
                <Link to="/audit/consults">
                  <MenuItem active={isAuditSearchConsultsPageActive}>
                    <img src={fileLines} alt="fileLines" />
                  Consultas
                  </MenuItem>
                </Link>
              )}

              {reclamationsPermissions && reclamationsPermissions.vizualizar && (
                <Link to="/reclamations">
                  <MenuItem active={isReclamationsPageActive}>
                    <img src={reclamation} alt="reclamation" />
                  Contestações
                  </MenuItem>
                </Link>
              )}

              {customerRequestsPermissions && customerRequestsPermissions.excluir && (
                <Link to="/customersRequests">
                  <MenuItem active={isCustomersRequestsPageActive}>
                    <img src={customersRequests} alt="reclamation" />
                  Solicitações Clientes
                  </MenuItem>
                </Link>
              )}

              <Link to="/unlockConsults">
                <MenuItem active={isUnlockConsultsPageActive}>
                  <img src={unlockConsults} alt="reclamation" />
                  Destravar Consultas
                </MenuItem>
              </Link>
              <Link to="/reprocessConsults">
                <MenuItem active={isReprocessConsultsPageActive}>
                  <img src={unlockConsults} alt="reclamation" />
                  Reprocessar Consultas
                </MenuItem>
              </Link>
              <Link to="/abateConsults">
                <MenuItem active={isAbateConsultsPageActive}>
                  <img src={unlockConsults} alt="abateConsults" />
                  Abater Consultas
                </MenuItem>
              </Link>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      )}

      {/* Internal Registrations */}
      {hasSomeInternalRegistrationPage && (
        <Accordion defaultActiveKey={isSomeInternalRegistrationPageActive ? '0' : undefined} flush>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <MenuItem>
                <img src={filePen} alt="bus" />
                {' '}
              Cadastros Internos
              </MenuItem>
            </Accordion.Header>
            <Accordion.Body>
              {unlockCompaniesPermissions?.vizualizar && (
                <Link to="/unlockingCompanies">
                  <MenuItem active={isUnlockingCompaniesPageActive}>
                    <img src={companyUnlock} alt="company" />
                Liberação de Empresas
                  </MenuItem>
                </Link>
              )}

              {operatorsPermissions?.vizualizar && (
                <Link to="/operators">
                  <MenuItem active={isOperatorsPageActive}>
                    <img src={carTunnel} alt="operators" />
                  Operadoras
                  </MenuItem>
                </Link>
              )}

              {vtItensPermissions?.vizualizar && (
                <>
                  <Link to="/vtItens">
                    <MenuItem active={isVtItensPageActive}>
                      <img src={ticket} alt="vtItens" />
                  Itens de VT
                    </MenuItem>
                  </Link>

                  <Link to="/integration">
                    <MenuItem active={isIntegrationPageActive}>
                      <img src={carBus} alt="integration" />
                  Regras de Integração
                    </MenuItem>
                  </Link>

                  <Link to="/biasTags">
                    <MenuItem active={isBiasTagsPageActive}>
                      <img src={biasTags} alt="biasTags" />
                      Bias Tags
                    </MenuItem>
                  </Link>
                </>
              )}

              {linesPermissions?.vizualizar && (
                <Link to="/transportLines">
                  <MenuItem active={isLinesPageActive}>
                    <img src={route} alt="transportLines" />
                  Linhas
                  </MenuItem>
                </Link>
              )}

              {internalUsersPermissions?.vizualizar && (
                <Link to="/internalUsers">
                  <MenuItem active={isInternalUsersPageActive}>
                    <img src={userTie} alt="bus" />
                  Usuários Internos
                  </MenuItem>
                </Link>
              )}

              {partnersPermissions?.vizualizar && (
                <Link to="/partners">
                  <MenuItem active={isPartnersPageActive}>
                    <img src={handshake} alt="bus" />
                  Parceiros
                  </MenuItem>
                </Link>
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      )}

      {generalReportsPermissions && generalReportsPermissions.vizualizar && (
        <MenuItem active={false} onClick={() => setGeneralReportsModalShow(true)}>
          <img src={downloadFile} alt="" />
          Relatórios Gerais
        </MenuItem>
      )}
    </>
  );
}
